// Vendor JS
import axios from 'axios';
import postscribe from 'postscribe';
import Debug from 'debug';

/* eslint-disable no-extend-native */
/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */

/**
 * For checking if a string is blank or contains only white-space
 * @returns {boolean}
 */
String.prototype.isEmpty = () => (this.length === 0 || !this.trim() || this === null);

class Cig {
	/**
	 * Check if a string is empty
	 * TODO: this exists in... ARM? in a much more built out way that handles multiple types
	 * @param string
	 */
	static isEmptyString(string) {
		if (typeof (string) !== 'string' && string === undefined) {
			return false;
		}
		return (string.length === 0 || !string.trim() || string === null);
	}

	/**
	 * Check if a string is JSON
	 * @param str String to check
	 * @returns {boolean}
	 */
	static isJSON(str) {
		try {
			JSON.parse(str);
		}
		catch (error) {
			return false;
		}
		return true;
	}

	/**
	 * Convert Kebab-Case string to Snake_Case
	 * @param string String to be converted
	 * @returns {string|bool} Converted String or False if string is empty
	 */
	static kebabCaseToSnakeCase(string) {
		return !this.isEmptyString(string) ? string.replace(/-/g, "_") : false;
	}

	/**
	 * Retrieves data from remote location and injects it into the HTML
	 *
	 * @param url {string} url/path to JSON/script file
	 * @param selector {string} ID/class selector of element to inject content
	 * @param callback {function} Callback to run
	 */
	static loadExternalScript = async (url, selector, callback) => {
		try {
			// DOM Element that will contain external script
			const scriptContainerEl = document.querySelector(selector);

			// Get External Script
			const response = await axios.get(url);

			// Remove all existing child elements
			while (scriptContainerEl.firstChild) {
				scriptContainerEl.removeChild(scriptContainerEl.firstChild);
			}

			// Inject content into fragment and execute (replaces native document.write)
			postscribe(selector, response.data);

			// Execute callback if passed
			if (callback) {
				callback();
			}

		} catch (err) {
			Debug(`cig:error:sage:class:Cig`)(`loadExternalScript Error: %s %o`, err.message, err);

			// We reached our target server, but it returned an error
			document.querySelector(selector).innerHTML = `<h3 class="error">ERROR: ${err.message}</h3>`;

			throw new Error(err);
		}
	};

	/**
	 * Check if a given email address uses a valid format
	 */
	static isValidEmailAddress(emailAddress) {
		const pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(emailAddress);
	}

	/**
	 * [What do I do?]
	 *
	 * @param form
	 *
	 * @return {{}}
	 */
	static serializeObject(form) {
		const o = {};
		const a = Cig.serializeArray(form);
		for (let i = 0, l = a.length; i < l; i++) {
			const item = a[i];
			const { name, value } = item;

			/** if the key already exists we convert it to an array */
			if (o[name] !== undefined) {
				if (!o[name].push) {
					/** convert to array */
					o[name] = [o[name]];
				}
				o[name].push(value);
			}
			else {
				o[name] = value;
			}
		}
		return o;
	} // end serializeObject function

	/**
	 * [What do I do?]
	 *
	 * @param form
	 *
	 * @return {{}}
	 */
	static serializeArray(form) {
		let field;
		let l;
		const s = [];

		if (typeof form === 'object' && form.nodeName === 'FORM') {
			const len = form.elements.length;

			for (let i = 0; i < len; i++) {
				field = (form.elements[i]);

				if (field.name && !field.disabled && field.type !== 'file' && field.type !== 'reset' && field.type !== 'submit' && field.type !== 'button') {

					if (field.type === 'select-multiple') {

						l = (form.elements[i].options.length);

						for (let j = 0; j < l; j++) {
							if (field.options[j].selected) {
								s[s.length] = { name: field.name, value: field.options[j].value };
							}
						}
					}
					else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
						s[s.length] = { name: field.name, value: field.value };
					}
				}
			}
		}
		return s;
	} // end SerializeArray

	/**
	 * Create a temporary Input field for copying to clipboard
	 * @param element HTML element
	 */
	static copyToClipboardNoInputElement(element) {
		const tempInput = document.createElement('INPUT');
		const body = document.getElementsByTagName('body')[0];

		body.appendChild(tempInput);
		tempInput.setAttribute('value', element.innerHTML);
		tempInput.select();
		document.execCommand('copy');
		body.removeChild(tempInput);
	}
}

export default Cig;
